"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
Object.defineProperty(exports, "useFilterData", {
  enumerable: true,
  get: function get() {
    return _hooks.useFilterData;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _input = require("@oneloop/input");
var _checkbox = require("@oneloop/checkbox");
var _hooks = require("@oneloop/hooks");
var _button = require("@oneloop/button");
var _excluded = ["children"],
  _excluded2 = ["children", "hover"],
  _excluded3 = ["children", "ellipsis", "disabled", "hover", "variantSize"],
  _excluded4 = ["children", "disabled", "hover", "isActive", "variantSize"],
  _excluded5 = ["children", "disabled", "hover", "isActive", "icon", "variantSize"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var List = exports.List = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    ref: ref,
    as: "ul"
  }, props, {
    __css: {
      listStyleType: 'none',
      padding: '4px'
    }
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingRight: '4px',
      'scroll-behavior': 'smooth',
      '::-webkit-scrollbar': {
        width: '4px'
      },
      '::-webkit-scrollbar-track': {
        '-webkit-border-radius': '4px',
        background: '#E4E8EA'
      },
      '::-webkit-scrollbar-thumb': {
        '-webkit-border-radius': '4px',
        background: '#6F838D'
      }
    }
  }, children));
});
var ListInput = function ListInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, {
    as: "span",
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 6px 12px',
      gap: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_input.Input, _extends({
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
      icon: "icon-buscar",
      fontSize: "14px"
    }),
    placeholder: "Search",
    variant: "inputSearchOutlined"
  }, props)));
};
var ListItem = function ListItem(_ref2) {
  var children = _ref2.children,
    _ref2$hover = _ref2.hover,
    hover = _ref2$hover === void 0 ? true : _ref2$hover,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "li",
    width: 1
  }, props, {
    __css: {
      py: '10px',
      px: '16px',
      display: 'inline-flex',
      // justifyContent: 'start',
      alignItems: 'center',
      fontFamily: 'primary'
      // ':hover': hover && { bg: 'neutral.1' },
    }
  }), /*#__PURE__*/_react["default"].createElement(_checkbox.Checkbox, null), children);
};
var ListDefault = function ListDefault(_ref3) {
  var children = _ref3.children,
    _ref3$ellipsis = _ref3.ellipsis,
    ellipsis = _ref3$ellipsis === void 0 ? false : _ref3$ellipsis,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$hover = _ref3.hover,
    hover = _ref3$hover === void 0 ? true : _ref3$hover,
    _ref3$variantSize = _ref3.variantSize,
    variantSize = _ref3$variantSize === void 0 ? 'dropdownSizeNormal' : _ref3$variantSize,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "li",
    width: 1
  }, props, {
    __css: {
      display: 'inline-flex',
      justifyContent: 'start',
      alignItems: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    variant: [disabled ? 'mainItemSmallListDisabled' : 'mainItemSmallList', variantSize],
    style: ellipsis ? {
      borderRadius: '0px',
      display: 'block',
      textAlign: 'initial',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    } : {
      borderRadius: '0px'
    }
  }, children)));
};
var ListMultiselect = function ListMultiselect(_ref4) {
  var children = _ref4.children,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    _ref4$hover = _ref4.hover,
    hover = _ref4$hover === void 0 ? true : _ref4$hover,
    isActive = _ref4.isActive,
    _ref4$variantSize = _ref4.variantSize,
    variantSize = _ref4$variantSize === void 0 ? 'dropdownSizeNormal' : _ref4$variantSize,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var _useToggle = (0, _hooks.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    active = _useToggle2[0],
    toggle = _useToggle2[1];
  if (isActive && !active) {
    toggle(true);
  }
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "li",
    width: 1
  }, props, {
    __css: {
      display: 'inline-flex',
      justifyContent: 'start',
      alignItems: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_button.ButtonIcon, {
    variant: [disabled ? 'mainItemSmallListDisabled' : 'mainItemSmallList', variantSize],
    active: active,
    onClick: toggle,
    text: children,
    hasCheckbox: true,
    maxWidth: true,
    holdPress: true,
    disabled: disabled,
    style: {
      borderRadius: '0px'
    }
  })));
};
var ListIcon = function ListIcon(_ref5) {
  var children = _ref5.children,
    _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
    _ref5$hover = _ref5.hover,
    hover = _ref5$hover === void 0 ? true : _ref5$hover,
    isActive = _ref5.isActive,
    icon = _ref5.icon,
    _ref5$variantSize = _ref5.variantSize,
    variantSize = _ref5$variantSize === void 0 ? 'dropdownSizeNormal' : _ref5$variantSize,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "li",
    width: 1
  }, props, {
    __css: {
      display: 'inline-flex',
      justifyContent: 'start',
      alignItems: 'center'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_button.ButtonIcon, {
    variant: [disabled ? 'mainItemSmallListDisabled' : 'mainItemSmallList', variantSize],
    icon: icon,
    text: children,
    style: {
      borderRadius: '0px'
    }
  })));
};
List.Default = ListDefault;
List.Multiselect = ListMultiselect;
List.Icon = ListIcon;
List.Search = ListInput;
List.Item = ListItem;
List.displayName = 'List';